import Flickity from 'flickity';

export default class ImageCarousel {
    constructor(container) {
        this.container = container;
        this.list = container.querySelector('.image-carousel-block__list');
        this.leftArrow = container.querySelector('.image-carousel-block__scroll-left');
        this.rightArrow = container.querySelector('.image-carousel-block__scroll-right');

        if (!this.list || !this.leftArrow || !this.rightArrow) {
            return;
        }

        const images = this.list.querySelectorAll('img');
        this.waitForImages(images, () => this.initCarousel());
    }

    waitForImages(images, callback) {
        let loaded = 0;
        const total = images.length;

        if (total === 0) {
            callback();
            return;
        }

        images.forEach((img) => {
            if (img.complete && img.naturalHeight !== 0) {
                loaded++;

            } else {
                img.addEventListener('load', onLoad, { once: true });
                img.addEventListener('error', onLoad, { once: true });
            }
        });

        function onLoad() {
            loaded++;
            if (loaded === total) {
                callback();
            }
        };

        setTimeout(callback, total * 200);
    }

    initCarousel() {
        if (this.container.getAttribute('data-carousel-loaded') === 'true') {
            return;
        }

        this.flickity = new Flickity(this.list, {
            contain: true,
            freeScroll: true,
            pageDots: false,
            prevNextButtons: false,
            draggable: true,
            cellSelector: '.image-carousel-block__item',
        });

        this.container.setAttribute('data-carousel-loading', 'false');
        this.container.setAttribute('data-carousel-loaded', 'true');

        this.bindArrowEvents();
        this.updateArrowVisibility();

        this.flickity.on('select', () => this.updateArrowVisibility());
    }

    bindArrowEvents() {
        this.leftArrow.addEventListener('click', () => this.flickity.previous());
        this.rightArrow.addEventListener('click', () => this.flickity.next());
    }

    updateArrowVisibility() {
        const slideCount = this.flickity.slides.length;

        if (slideCount <= 1 || this.flickity.options.wrapAround) {
            this.leftArrow.classList.add('visible');
            this.rightArrow.classList.add('visible');
            return;
        }

        const isFirst = this.flickity.selectedIndex === 0;
        const isLast = this.flickity.selectedIndex === slideCount - 1;

        this.leftArrow.classList.toggle('visible', !isFirst);
        this.rightArrow.classList.toggle('visible', !isLast);
    }
}